import React, { useState, useEffect } from 'react';

const COOKIE_KEY = 'enzlo_cookie_consent_v1';

const defaultPrefs = {
  necessary: true,
  analytics: false,
  marketing: false,
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [prefs, setPrefs] = useState(defaultPrefs);
  const [showPrefs, setShowPrefs] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(COOKIE_KEY);
    if (!saved) setVisible(true);
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ ...defaultPrefs, analytics: true, marketing: true }));
    setVisible(false);
  };

  const handleSavePrefs = () => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify(prefs));
    setVisible(false);
  };

  const handleChange = (type) => {
    setPrefs((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      background: 'rgba(255,255,255,0.97)',
      boxShadow: '0 -2px 16px rgba(0,0,0,0.08)',
      zIndex: 9999,
      padding: '1.2rem 0.5rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      fontSize: '1rem',
    }}>
      <div style={{ maxWidth: 600, textAlign: 'center', color: '#334155' }}>
        We use cookies to optimize our website and service. <a href="/privacy" style={{ color: '#3b82f6', textDecoration: 'underline' }}>Learn more</a>.
      </div>
      {showPrefs ? (
        <div style={{ margin: '1rem 0', background: '#f1f5f9', borderRadius: 8, padding: '1rem', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
          <div style={{ marginBottom: 8 }}>
            <label>
              <input type="checkbox" checked disabled style={{ marginRight: 8 }} />
              Necessary cookies (always active)
            </label>
          </div>
          <div style={{ marginBottom: 8 }}>
            <label>
              <input type="checkbox" checked={prefs.analytics} onChange={() => handleChange('analytics')} style={{ marginRight: 8 }} />
              Analytics cookies
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" checked={prefs.marketing} onChange={() => handleChange('marketing')} style={{ marginRight: 8 }} />
              Marketing cookies
            </label>
          </div>
        </div>
      ) : null}
      <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
        {!showPrefs && (
          <button onClick={handleAcceptAll} style={{ background: 'linear-gradient(90deg,#3b82f6,#fbbf24)', color: '#fff', border: 'none', borderRadius: 20, padding: '0.6rem 1.5rem', fontWeight: 600, cursor: 'pointer', fontSize: '1rem' }}>
            Accept all
          </button>
        )}
        {!showPrefs && (
          <button onClick={() => setShowPrefs(true)} style={{ background: '#f1f5f9', color: '#334155', border: '1px solid #cbd5e1', borderRadius: 20, padding: '0.6rem 1.5rem', fontWeight: 500, cursor: 'pointer', fontSize: '1rem' }}>
            Adjust
          </button>
        )}
        {showPrefs && (
          <button onClick={handleSavePrefs} style={{ background: 'linear-gradient(90deg,#3b82f6,#fbbf24)', color: '#fff', border: 'none', borderRadius: 20, padding: '0.6rem 1.5rem', fontWeight: 600, cursor: 'pointer', fontSize: '1rem' }}>
            Save preferences
          </button>
        )}
      </div>
    </div>
  );
};

export default CookieConsent; 